
import './style.scss';

const PILL_COUNT = 4;

export function CondoWeeksCardSkeleton({ displayButton = true }: { displayButton?: boolean }) {
  return (
    <div className="condo-weeks-card-wrapper skeleton-card-weeks-wrapper">
      <div className="condo-weeks-card-new skeleton-card-weeks">
        <div className="condo-weeks-card-new__image-wrap skeleton-card-weeks__image">
          <div className="skeleton-card-weeks__image-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 64 64" fill="none">
              <rect x="6" y="10" width="52" height="44" rx="4" stroke="#bcbcbc" strokeWidth="2" />
              <circle cx="20" cy="24" r="4" fill="#bcbcbc" />
              <path d="M10 50l14-14 12 12 6-6 12 12" stroke="#bcbcbc" strokeWidth="2" fill="none" strokeLinejoin="round" />
            </svg>
          </div>
        </div>

        <div className="condo-weeks-card-new__body">
          <div className="skeleton-card-weeks__line skeleton-card-weeks__line--title" />
          <div className="skeleton-card-weeks__line skeleton-card-weeks__line--location" />

          <div className="condo-weeks-card-new__pills skeleton-card-weeks__pills">
            {Array.from({ length: PILL_COUNT }).map((_, i) => (
              <div className="skeleton-card-weeks__pill" key={`pill_skeleton_${i}`} />
            ))}
          </div>

          <div className="condo-weeks-card-new__footer skeleton-card-weeks__footer">
            <div className="skeleton-card-weeks__line skeleton-card-weeks__line--dates" />
            {displayButton ? (
              <div className="skeleton-card-weeks__line skeleton-card-weeks__line--book" />) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
